import { render } from "./SpaTreatmentSummary.vue?vue&type=template&id=f7e984e4"
import script from "./SpaTreatmentSummary.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentSummary.vue?vue&type=script&lang=js"

import "./SpaTreatmentSummary.vue?vue&type=style&index=0&id=f7e984e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__